export const orderType = {
  GET_ORDER_DATA: "GET_ORDER_DATA",
  GET_IMAGE: "GET_IMAGE",
  LOG_OUT: "LOG_OUT",
  GET_UPDATED_ORDER_DATA: "GET_UPDATED_ORDER_DATA",
  SINGLE_ORDER_LOADER_TRUE: "SINGLE_ORDER_LOADER_TRUE",
  GET_SINGLE_ORDER_DATA: "GET_SINGLE_ORDER_DATA",
};
